import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bicycle-card',
  templateUrl: './bicycle-card.component.html',
  styleUrls: ['./bicycle-card.component.css']
})
export class BicycleCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
